<template>
  <b-card>
    <!-- media -->
    <b-media no-body>
      <b-media-aside>
        <croppa
          v-model="croppaFoto"
          :width="170"
          :height="200"
          placeholder="Subir foto"
          placeholder-color="#543338"
          :placeholder-font-size="16"
          canvas-color="transparent"
          :show-remove-button="true"
          remove-button-color="black"
          :show-loading="false"
          :loading-size="50"
          loading-color="#606060"
          :quality="1"
          :initial-image="usuario.foto"
        ></croppa>
        <!--/ avatar -->
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <!--/ reset -->
        <!-- <b-card-text>Allowed JPG, GIF or PNG. Max size of 800kB</b-card-text> -->
      </b-media-body>
    </b-media>
    <!--/ media -->

    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Usuario ingreso (Login)"
            label-for="account-username"
          >
            <b-form-input
              id="usuario"
              v-model="usuario.usuario"
              placeholder="Usuario"
              name="username"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Nombre" label-for="account-name">
            <b-form-input
              name="name"
              placeholder="Nombre"
              :value="usuario.nombre + ' ' + usuario.apellido"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="E-mail" label-for="account-e-mail">
            <b-form-input
              id="email-user"
              v-model="usuario.email_user"
              name="email"
              placeholder="Email"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Institución" label-for="account-company">
            <b-form-input
              name="company"
              placeholder="Institución"
              :value="usuario.institucion"
              disabled
            />
          </b-form-group>
        </b-col>

        <!-- alert -->
        <!-- <b-col cols="12" class="mt-75">
          <b-alert show variant="warning" class="mb-50">
            <h4 class="alert-heading">
              Your email is not confirmed. Please check your inbox.
            </h4>
            <div class="alert-body">
              <b-link class="alert-link">
                Resend confirmation
              </b-link>
            </div>
          </b-alert>
        </b-col> -->
        <!--/ alert -->

        <b-col cols="4">
          <b-button
            v-if="!showLoading"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="savePerfil"
          >
            Guardar
          </b-button>
        </b-col>
        <b-col md="8">
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; top:15px;  width:92%; margin-left:-4px; z-index:1000"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </b-col>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  // BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  // BAlert,
  BCard,
  // BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BSpinner,
  BAlert,
  // BLink,
  // BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightFade } from '@core/directives/animations'
import { ref } from '@vue/composition-api'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import { URL, USER, STORAGE_NAME } from '../../utils/variables'

export default {
  components: {
    BButton,
    BForm,
    // BImg,
    // BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    // BAlert,
    BCard,
    // BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BSpinner,
    BAlert,
    // BLink,
  },
  directives: {
    Ripple,
    heightFade,
  },
  props: {
    usuario: Object,
  },
  setup(props) {
    const croppaFoto = ref({})
    const showLoading = ref(false)
    const { postApi } = apiCall()
    const messageError = ref('')
    const variante = ref('danger')
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const hasError = ref(false)
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function getPicturePlayer(croppa) {
      let fotografia = ''
      if (croppa.value.chosenFile == null) {
        fotografia = ''
      } else {
        const fotografiaBase64 = croppa.value.generateDataUrl(
          'image/jpeg',
          // eslint-disable-next-line
          0.5
        )
        fotografia = fotografiaBase64
      }
      return fotografia
    }
    function validarEmail(email) {
      // eslint-disable-next-line
      const expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
      let vale = false
      if (!expr.test(email)) {
        vale = false
      } else {
        vale = true
      }
      return vale
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function focusInput(id, error) {
      document.getElementById(id).focus()
      showMessageAlert('danger', error)
    }
    function hasErrorForm() {
      // console.log(refCi)
      // console.log(props.user)
      let error = false
      if (
        props.usuario.usuario === '' ||
        props.usuario.usuario === null ||
        props.usuario.usuario === undefined
      ) {
        focusInput('usuario', 'Usuario no debe ser vacío')
        error = true
      } else if (
        props.usuario.email_user === '' ||
        props.usuario.email_user === null ||
        props.usuario.email_user === undefined
      ) {
        focusInput('email-user', 'Email es requerido')
        error = true
      } else if (!validarEmail(props.usuario.email_user)) {
        focusInput(
          'email-user',
          // eslint-disable-next-line
          'Email debe ser válido ejm: xyz@hotmail.com'
        )
        error = true
      } else {
        error = false
      }
      return error
    }
    async function savePerfil() {
      if (!hasErrorForm()) {
        showLoading.value = true
        props.usuario.fotografia = getPicturePlayer(croppaFoto)
        const path = 'ApiUsuario/updatePerfil'
        const response = await postApi(URL, path, props.usuario)
        // console.log(response)
        if (response.flag === 'si') {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'ACTUALIZADO con éxito',
                icon: 'AlertCircleIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'bottom-center',
              // eslint-disable-next-line
            }
          )
          const newUser = { ...USER() }
          newUser.usuario = props.usuario.usuario
          newUser.email_user = props.usuario.email_user
          if (response.foto !== '') {
            newUser.foto = response.foto
            store.commit('someVariables/UPDATE_PERFIL', newUser)
          }
          localStorage.setItem(STORAGE_NAME, JSON.stringify(newUser))
        } else {
          showMessageAlert('danger', response.mensaje)
        }
        showLoading.value = false
      }
    }
    return {
      croppaFoto,
      savePerfil,
      showLoading,
      countDownChanged,
      messageError,
      dismissCountDown,
      variante,
    }
  },
}
</script>
